import React from 'react';
import styles from './ruler.module.scss';

export function Ruler({ isHidden }: { isHidden?: boolean }) {
	const style = isHidden ? { borderColor: 'transparent' } : undefined;

	return <hr style={style} className={styles.ruler} />;
}
